<template>
  <div
    class="ui basic tiny modal"
    :id="modalId">
    <template v-if="status === 'ready'">
      <div
        class="ui icon header">
        <i class="yellow warning sign icon"/>
        {{ $t('patients.contentDeactivationModal.warningTitle', { itemType: $tc(itemType.toLowerCase(), 1), itemShortName: content.data.shortName }) }}
      </div>

      <div class="content">
        <p>{{ $t('patients.contentDeactivationModal.warningMessage', { itemType: $tc(itemType.toLowerCase(), 1) }) }}</p>
      </div>

      <br>

      <div class="actions">
        <div
          class="ui left floated inverted button"
          @click="closeModal">
          {{ $t('no') }}
        </div>
        <div
          class="ui right floated red inverted button"
          @click.once="deactivateSelectedAddedContent">
          {{ $t('patients.contentDeactivationModal.yesDeactivate') }}
        </div>
      </div>
    </template>

    <div
      v-else-if="status === 'pending'"
      class="ui big loader"/>

    <template v-else-if="status === 'success'">
      <div class="ui icon header">
        <i class="green checkmark icon"/>
        {{ $t('patients.contentDeactivationModal.confirmationTitle', { itemType: $tc(itemType.toLowerCase(), 1) }) }}
      </div>

      <div class="content">
        {{ $t('patients.contentDeactivationModal.confirmationMessage', { itemShortName: content.data.shortName }) }}
      </div>

      <div
        class="actions"
        style="display: flex; flex-direction: row; justify-content: center">
        <div
          class="ui primary inverted button"
          @click="closeModal">
          <i class="close icon"/>{{ $t('close') }}
        </div>
      </div>
    </template>

    <template v-else-if="status === 'failure'">
      <div class="ui icon header">
        <i class="red exclamation icon"/>
        {{ $t('patients.contentDeactivationModal.failureTitle', { itemType: $tc(itemType.toLowerCase(), 1) }) }}
      </div>
      <div class="content">
        <p>{{ $t('patients.contentDeactivationModal.failureMessage', { itemType: $tc(itemType.toLowerCase(), 1) }) }}</p>
      </div>
      <div class="actions">
        <div
          @click="closeModal"
          class="ui inverted primary ok button">
          <i class="checkmark icon"/>
          {{ $t('okay') }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ContentDeactivationModal',
  props: {
    status: {
      type: String,
      required: true
    }
  },
  computed: {
    itemType () { return 'content' },
    modalId () { return `deactivate-content-modal-${this._uid}` }
  },
  methods: {
    deactivateSelectedAddedContent () {
      this.$emit('deactivate-selected-added-content')
    },
    closeModal () {
      $('#' + this.modalId)
        .modal('reset')
        .modal('hide')

      this.$emit('update-reminders')
    }
  },
  beforeDestroy () {
    let modal = $('#' + this.modalId)
    if (modal !== null) {
      modal.remove()
    }
  }
}
</script>

<style scoped>
</style>
